import { MoreHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import { FLOATING_MENU_ITEM_CLASS, FLOATING_PANEL_CLASS } from '@/styles/floatingPanel';
import type { RowAction } from './rowAction.types';

const MENU_CLASS = cn('w-44 p-1.5', FLOATING_PANEL_CLASS);

interface RowMoreActionsMenuProps {
  actions: readonly RowAction[];
  ariaLabel: string;
}

export function RowMoreActionsMenu({ actions, ariaLabel }: RowMoreActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            type="button"
            variant="outline"
            size="icon-sm"
            aria-label={ariaLabel}
            onClick={(event) => event.stopPropagation()}
          >
            <MoreHorizontal className="size-4" aria-hidden />
          </Button>
        }
      />
      <DropdownMenuContent align="end" className={MENU_CLASS}>
        {actions.map(({ key, label, onSelect, tone = 'default', isDisabled }) => (
          <DropdownMenuItem
            key={key}
            variant={tone}
            disabled={isDisabled === true}
            className={FLOATING_MENU_ITEM_CLASS}
            onClick={(event) => {
              event.stopPropagation();
              onSelect();
            }}
          >
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
